import { DICT_DEFAULT_RESOURCE_TEXT, EventTypes, EventValues, ModalStepsLabel } from "../utils/constants";
import { buildUri } from "../utils/dom";
import SectionComponent from "./section.component";

export default class AppointmentTimeComponent extends SectionComponent {
    
    #datePickerURL = buildUri(v24Scheduler.staticDomain, '/v24/veedesk/self-scheduler/vee24-inline-date-picker/inline-date-picker.html');
    #resourcesService;
    #analyticsService;

    get #calendarComponent() {
        return this.querySelector("vee24-scheduler-appointment-calendar-section");
    }

    get #timeSlotComponent() {
        return this.querySelector("vee24-scheduler-appointment-timeslot-section");
    }

    get maxAllowedDays() {
        try {
            return parseInt(
                this.#resourcesService.getResource(
                    "SELFSCHEDULER_MAXALLOWEDDATE",
                    DICT_DEFAULT_RESOURCE_TEXT.SELFSCHEDULER_MAXALLOWEDDATE
                )
            );
        } catch (error) {
            console.warn("Invalid value while parsing MaxAllowedDate", error);
        }
    }

    get errorMessage() {
  
            return this.#resourcesService.getResource(
                "SELFSCHEDULER_ERRORONCALENDAR",
                DICT_DEFAULT_RESOURCE_TEXT.SELFSCHEDULER_ERRORONCALENDAR
            );
     
    }


    constructor() {
        super();
    }

    init(resourcesService, analyticsService) {
        this.#resourcesService = resourcesService;
        this.#analyticsService = analyticsService;
    }

    setAriaLabels() {
        const headerInstructionsAriaLabel = this.#resourcesService.getResource("SELFSCHEDULER_CALHEADER_INSTRUCTIONS_ARIA_LABEL", DICT_DEFAULT_RESOURCE_TEXT.SELFSCHEDULER_CALHEADER_INSTRUCTIONS_ARIA_LABEL);
        const bodyInstructionsAriaLabel = this.#resourcesService.getResource("SELFSCHEDULER_CALBODY_INSTRUCTIONS_ARIA_LABEL", DICT_DEFAULT_RESOURCE_TEXT.SELFSCHEDULER_CALBODY_INSTRUCTIONS_ARIA_LABEL);

        const header = this.#calendarComponent.querySelector('.v24-cal-header');
        const body = this.#calendarComponent.querySelector('.v24-cal-body');

        header.setAttribute('aria-label', headerInstructionsAriaLabel);
        body.setAttribute('aria-label', bodyInstructionsAriaLabel);
    }

    setupCalendarComponent(nextAvailableDate) {
        this.setContent(`<vee24-scheduler-appointment-calendar-section></vee24-scheduler-appointment-calendar-section><vee24-scheduler-appointment-timeslot-section class="section" tabindex="-1"></vee24-scheduler-appointment-timeslot-section>`);
        this.#calendarComponent.init(this.#resourcesService, this.#analyticsService);
        this.fetchCalendarContent(nextAvailableDate);
    }

    setupTimeslotComponent(operatorTimeSlots, culture, use24hourClock, aptDate) {
        this.#timeSlotComponent.init(this.#resourcesService, this.#analyticsService, culture, use24hourClock, aptDate);
        this.#timeSlotComponent.createTimeslots(operatorTimeSlots);
        this.#timeSlotComponent.focus();
    }

    fetchCalendarContent(nextAvailableDate) {
        fetch(this.#datePickerURL)
        .then((response) => response.text())
        .then((response) => {
            this.#calendarComponent.populateCalendar(
              response,
              this.maxAllowedDays,
              this.createWeekHTML()
            );
            if (nextAvailableDate) {
                this.#calendarComponent.selectCalendarDate(nextAvailableDate);
            } else {
                this.showNoAppointmentsForTypeError();
            }
            this.setAriaLabels();
        })
        .catch((error) => {
          console.warn("Error Loading Calendar Page.", error);
          this.setContent(this.errorMessage);
        });
    }

    showNoAppointmentsForTypeError() {
        this.#timeSlotComponent.setContent(`<div tabindex="-1" class="v24-timeslot-error">${this.#resourcesService.getResource("SELFSCHEDULER_NOAPPOINTMENTSFORTYPE",DICT_DEFAULT_RESOURCE_TEXT.SELFSCHEDULER_NOAPPOINTMENTSFORTYPE)}`);
        this.#calendarComponent.disableAllCalendarDates();
        this.#analyticsService.send(EventTypes.Error, EventValues.NoAppointmentsForTypeAvailable, ModalStepsLabel.appointmentSelectionStep);
    }

    createWeekHTML() {
        const weekHtml = []
        const days = ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"]
        days.forEach((day) => {
            weekHtml.push(`<span tabindex="-1">${this.getDayResource(day)}</span>`);
        });
        return weekHtml.join("");
    }

    getDayResource(day) {
        return this.#resourcesService.getResource(
            `SELFSCHEDULER_CALWEEK_ABR_${day.toUpperCase()}`,
            DICT_DEFAULT_RESOURCE_TEXT[`SELFSCHEDULER_CALWEEK_ABR_${day.toUpperCase()}`]
        );
    }

    clear() {
        this.setContent("");
    }

    resetTimeslot() {
        if (this.#timeSlotComponent) {
            this.#timeSlotComponent.clear();
        }
    }
}
